import React, { Component } from "react"
// import PropTypes from "prop-types";
import TextView from "./TextView"
import Body from "./Body"
import Row from "./Row"
import RowCarousel from "./RowCarousel"
import DividerView from "./DividerView"
import AvatarView from "./AvatarView"
import ImageView from "./ImageView"
import ImageTextView from "./ImageTextView"
import CarouselView from "./CarouselView"
import FlatButtonView from "./FlatButtonView"
import IconButtonView from "./IconButtonView"
import FAButtonView from "./FAButtonView"
import ProductListView from "./ProductListView"
import YoutubeView from "./YoutubeView"
import ContentCarousel from "./ContentCarousel"
import CarouselAnimationView from "./CarouselAnimationView"
import DealGroupView from "./DealGroupView"
import { DivContainer } from "./styled"

class PropsPlugin extends Component {
  constructor(props) {
    super(props)
    let item = props.layoutState.getSelectedItem()
    this.state = {
      item: item.props,
      type: item.type,
      itemId: item.id,
    }
    // this.onUpdateData = this.onUpdateData.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.layoutState.selectedItem &&
      nextProps.layoutState.selectedItem !== this.props.layoutState.selectedItem
    ) {
      let item = nextProps.layoutState.getSelectedItem()
      this.setState({ item: item.props, type: item.type, itemId: item.id })
    }
  }

  onUpdateData = (data) => {
    try {
      this.props.layoutState.updateItem(this.props.layoutState.selectedItem)(
        ["props"],
        () => data
      )
    } catch (err) {
      console.log(err.message)
    }
  }
  onUpdateDataCarousel = (data) => {
    let newData = data
    // console.log(data);
    let dataContent = []
    for (let index = 0; index < data.content.length; index++) {
      const element = data.content[index]
      const newItem = {
        childOf: element.childOf,
        children: element.children,
        props: element.props,
        parent: element.parent,
        id: element.id,
        type: element.type,
      }
      dataContent.push(newItem)
    }
    newData["content"] = dataContent
    // console.log(newData);
    try {
      this.props.layoutState.updateItem(this.props.layoutState.selectedItem)(
        ["props"],
        () => newData
      )
    } catch (err) {
      console.log(err.message)
    }
  }
  render() {
    // console.log(this.props.layoutState.getSelectedItem());
    if (this.state.type === "Body") {
      return (
        <DivContainer>
          <Body
            data={this.state.item}
            onUpdateData={(data) => this.onUpdateData(data)}
          />
        </DivContainer>
      )
    }
    if (this.state.type === "Row7") {
      return (
        <DivContainer>
          <RowCarousel
            data={this.state.item}
            {...this.props}
            onUpdateData={(data) => this.onUpdateDataCarousel(data)}
          />
        </DivContainer>
      )
    } else if (this.state.type === "ContentCarousel") {
      return (
        <DivContainer>
          <ContentCarousel
            data={this.state.item}
            {...this.props}
            onUpdateData={(data) => this.onUpdateData(data)}
          />
        </DivContainer>
      )
    } else {
      let elementComponent = <div>Please Close and select again</div>
      const item = dataPropreties(
        this.state.item,
        this.state.itemId,
        this.onUpdateData,
        this.props
      )
      if (item[this.state.item.values.type]) {
        elementComponent = item[this.state.item.values.type]
      } else {
        elementComponent = <div>Please Close and select again</div>
      }

      return <DivContainer>{elementComponent}</DivContainer>
    }
  }
}

PropsPlugin.Title = "Props"

const dataPropreties = (item, id, onUpdateData, props) => {
  return {
    Row: (
      <Row data={item} id={id} onUpdateData={(data) => onUpdateData(data)} />
    ),
    TextView: (
      <TextView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),

    DividerView: (
      <DividerView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    AvatarView: (
      <AvatarView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    ImageView: (
      <ImageView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    ImageTextView: (
      <ImageTextView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    CarouselView: (
      <CarouselView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    FlatButtonView: (
      <FlatButtonView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    IconButtonView: (
      <IconButtonView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    FAButtonView: (
      <FAButtonView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    ProductListView: (
      <ProductListView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
        {...props}
      />
    ),
    YoutubeView: (
      <YoutubeView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    CarouselAnimationView: (
      <CarouselAnimationView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
    DealGroupView: (
      <DealGroupView
        data={item}
        id={id}
        onUpdateData={(data) => onUpdateData(data)}
      />
    ),
  }
}
export default {
  Title: "Props",
  Interface: PropsPlugin,
}



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/index.js